import anime from 'animejs';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { newDate } from '../../../../../utils/date';
import type { LotteryDrawResult } from '../../../types';
import { prizeList2goodsList } from '../../../utils';

export function useLotteryDrawAnime(lotteryDrawResult: LotteryDrawResult, isFromFamipay = false) {
  const router = useRouter();
  const [scene, setScene] = useState(1);
  const [currentGoodsIndex, setCurrentGoodsIndex] = useState(0);
  const [gifUrl, setGifUrl] = useState('');

  // prizeList2goodsList の処理を内包
  const goodsList = prizeList2goodsList(lotteryDrawResult.prize);

  // goodsListがない=ハズレ=特殊値入れておく
  const maxRank = goodsList.length > 0 ? goodsList.map((v) => v.stagingRank).sort()[0] : '-1';

  // アニメーションタイムライン
  const timeline = anime.timeline({
    duration: 1000,
    autoplay: false,
  });
  timeline.add({
    targets: '#imageWrapper',
    easing: 'linear',
    opacity: [0, 1],
    duration: 1000,
  });
  timeline.add({
    targets: '#textCongrats',
    easing: 'easeOutBounce',
    opacity: [0, 1],
    duration: 750,
    translateY: ['-100%', '0'],
  });
  timeline.add(
    {
      targets: '.footInfo',
      easing: 'easeOutExpo',
      opacity: [0, 1],
      duration: 750,
    },
    '-=250',
  );
  const timelineScene2 = timeline;

  // GIFのURL設定
  useEffect(() => {
    // マウント後に入れないと不整合warningが出る
    let stagingColor = 'silver';
    switch (maxRank) {
      // ハズレ
      case '-1':
        stagingColor = 'nothing';
        break;
      // 虹
      case '1':
        stagingColor = 'rainbow';
        break;
      // 金
      case '2':
        stagingColor = 'gold';
        break;
    }
    setGifUrl(`url(/anime/sp/animation_intro_${stagingColor}.gif?t=${newDate().getTime()})`);
  }, [goodsList.length, maxRank]);

  // シーン遷移ロジック
  useEffect(() => {
    const timer = setTimeout(() => {
      if (scene !== 1) return;
      if (goodsList.length === 0) {
        // ハズレ
        router.replace(`/draw/${lotteryDrawResult.historyId}/nothing`);
      } else {
        // あたり（通常）
        setScene(2);
        timelineScene2.play();
      }
    }, 6000);

    return () => {
      clearTimeout(timer);
    };
  }, [goodsList.length, lotteryDrawResult.historyId, router, scene, timelineScene2]);

  // ブラウザバック抑制（修正版）
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const browserBackBlockFunc = () => {
      history.go(1);
    };

    window.history.pushState(null, '', location.href);
    window.addEventListener('popstate', browserBackBlockFunc);

    return () => {
      window.removeEventListener('popstate', browserBackBlockFunc);
    };
  }, []);

  // 現在の商品取得
  const currentGoods = () => {
    return goodsList[currentGoodsIndex];
  };

  // 結果画面への遷移
  const goResult = (e: React.MouseEvent) => {
    e.preventDefault();
    router.replace(`/draw/${lotteryDrawResult.historyId}/result`);
  };

  // 次の商品への遷移
  const nextGoods = () => {
    if (currentGoodsIndex + 1 === goodsList.length) {
      // 結果画面へ
      router.replace(`/draw/${lotteryDrawResult.historyId}/result`);
    } else {
      // シーン2へ
      setCurrentGoodsIndex(currentGoodsIndex + 1);
      timelineScene2.restart();
    }
  };

  return {
    scene,
    currentGoodsIndex,
    gifUrl,
    goodsList,
    maxRank,
    currentGoods,
    goResult,
    nextGoods,
    isShowLogo: !isFromFamipay,
  };
}
